import React, { useEffect, useState } from 'react';
import { Space, Spin, Select, Divider, Button, App, Collapse, Badge, List, Form, Modal } from 'antd';
import { _T } from "../../../../../base-react/src/Localization";
import { apis, hooks, models } from "@vote4dance/judging-sdk";
import { useCompetition } from '../../../../../base-react/hooks/Competition';
var Api = apis.Api;
var Stream = hooks.streams.Stream;
var RegistrationClassSource = models.registration.RegistrationClassSource;
var ClassesSource = models.classes.ClassesSource;
import { ButtonConfirm } from '../../../../../base-react/components/ButtonConfirm';
import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons';
import { RegistrationRulesPreview } from './RegistrationRulesPreview';
import { RegistrationRulesForm } from './RegistrationRulesForm';
export const RegistrationClassList = (props) => {
    const { competition_id, registration_period_id } = props;
    const [, , , , , canEdit] = useCompetition(competition_id);
    const [classes, loading] = Stream(RegistrationClassSource(competition_id, registration_period_id));
    if (loading) {
        return React.createElement(Spin, null);
    }
    return (React.createElement(Collapse, { collapsible: "header", items: [
            {
                key: 'classes',
                label: _T('registrationperiod.classes'),
                extra: classes && React.createElement(Badge, { count: classes.length, style: { marginLeft: 12 } }),
                children: React.createElement(React.Fragment, null,
                    React.createElement(List, { dataSource: classes, bordered: true, loading: loading, style: { width: '100%' }, renderItem: (item) => (React.createElement(List.Item, { actions: [
                                React.createElement(EditRegistrationClass, { item: item, competition_id: competition_id, registration_period_id: registration_period_id, disabled: !canEdit })
                            ] },
                            React.createElement(List.Item.Meta, { title: item.class_label || item.class_name, description: React.createElement(RegistrationRulesPreview, { registration_rules: item.registration_rules, registration_form: item.registration_form }) }))) }),
                    React.createElement(Divider, null),
                    React.createElement(AddRegistrationClass, { key: competition_id, competition_id: competition_id, registration_period_id: registration_period_id, existingClasses: classes }))
            }
        ] }));
};
const AddRegistrationClass = (props) => {
    const { competition_id, registration_period_id, existingClasses } = props;
    const [classes, loading] = Stream(ClassesSource(competition_id));
    const [filteredClasses, setFilteredClasses] = useState([]);
    const [selected, setSelected] = useState([]);
    const { notification } = App.useApp();
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        const existingIds = existingClasses === null || existingClasses === void 0 ? void 0 : existingClasses.map(a => a.class_id);
        setFilteredClasses(classes ? classes.filter(a => !(existingIds === null || existingIds === void 0 ? void 0 : existingIds.includes(a.class_id))) : []);
    }, [classes, existingClasses]);
    const handleChange = (value) => {
        setSelected(value);
    };
    const selectAll = async () => {
        setSelected(filteredClasses.map(a => a.class_id));
    };
    const addSelected = async () => {
        setIsLoading(true);
        for (const class_id of selected) {
            const updateItem = {
                registration_period_id,
                class_id,
                competition_id: competition_id
            };
            await Api.create(RegistrationClassSource(competition_id, registration_period_id).url, updateItem)
                .catch(err => {
                notification.error({
                    message: err.response && err.response.message ? _T(err.response.message) : err.message
                });
            });
        }
        setSelected([]);
        setIsLoading(false);
    };
    return (React.createElement(Select, { mode: "multiple", allowClear: true, value: selected, showSearch: true, style: { width: 300 }, placeholder: _T('common.select', { name: _T('class.plural').toLowerCase() }), onChange: handleChange, options: filteredClasses === null || filteredClasses === void 0 ? void 0 : filteredClasses.map(a => ({
            label: a.class_label || a.class_name,
            value: a.class_id
        })), filterOption: (input, option) => { var _a, _b; return ((_b = (_a = option === null || option === void 0 ? void 0 : option.label) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : '').includes(input.toLowerCase()); }, dropdownRender: (menu) => (React.createElement(React.Fragment, null,
            menu,
            React.createElement(Divider, { style: { margin: '8px 0' } }),
            React.createElement(Space, null,
                React.createElement(Button, { loading: isLoading, onClick: selectAll }, _T('common.select', { name: _T('common.all').toLowerCase() })),
                React.createElement(Button, { type: "primary", loading: isLoading, disabled: !selected.length, onClick: addSelected }, _T('common.add', { name: selected.length || '' }))))) }));
};
export const EditRegistrationClass = (props) => {
    const { item, competition_id, registration_period_id, disabled } = props;
    const [isLoading, setIsLoading] = useState(false);
    const [visible, setVisible] = useState(false);
    const [form] = Form.useForm();
    const { notification } = App.useApp();
    const registrationClassSource = RegistrationClassSource(competition_id, registration_period_id);
    const openModal = () => {
        setVisible(true);
    };
    const handleCancel = () => {
        form.resetFields();
        setVisible(false);
    };
    useEffect(() => {
        if (form) {
            form.resetFields();
        }
    }, []);
    const getDefaultValue = () => ({
        ...item,
        registration_rules: item.registration_rules ? JSON.parse(item.registration_rules) : [],
        registration_form: item.registration_form ? JSON.parse(item.registration_form) : [],
    });
    useEffect(() => {
        if (form && item) {
            form.setFieldsValue(getDefaultValue());
        }
    }, [item]);
    const onFinish = async (fieldsValue) => {
        var _a, _b;
        const updateItem = {
            ...item,
            ...fieldsValue,
            registration_rules: ((_a = fieldsValue['registration_rules']) === null || _a === void 0 ? void 0 : _a.length) > 0 ? JSON.stringify(fieldsValue['registration_rules']) : null,
            registration_form: ((_b = fieldsValue['registration_form']) === null || _b === void 0 ? void 0 : _b.length) > 0 ? JSON.stringify(fieldsValue['registration_form']) : null
        };
        setIsLoading(true);
        try {
            await Api.update(`${registrationClassSource.url}/${item.class_id}`, updateItem);
            handleCancel();
        }
        catch (err) {
            notification.error({
                message: err.response && err.response.message ? _T(err.response.message) : err.message
            });
        }
        setIsLoading(false);
    };
    const onDeleteRound = async (item, done) => {
        await Api.destroy(`${registrationClassSource.url}/${item.class_id}`)
            .catch((err) => {
            notification.error({
                message: err.response.message ? _T(err.response.message) : err.message
            });
        });
        done();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { disabled: disabled, type: "text", icon: item ? React.createElement(EditOutlined, null) : React.createElement(PlusOutlined, null), onClick: openModal }),
        React.createElement(Modal, { title: _T(item ? 'common.edit' : 'common.add', { name: _T('registration.rules.title').toLowerCase() }), open: visible, width: 700, onCancel: handleCancel, destroyOnHidden: true, footer: [
                item &&
                    React.createElement(ButtonConfirm, { title: _T('common.delete.title'), description: _T('common.delete.content', { name: _T('registrationperiod.title').toLowerCase() }), onConfirm: (done) => onDeleteRound(item, done), key: "delete", buttonProps: {
                            danger: true,
                            icon: React.createElement(DeleteOutlined, null)
                        } }),
                React.createElement(Button, { key: "cancel", onClick: handleCancel }, _T('common.cancel.title')),
                React.createElement(Button, { key: "submit", type: "primary", form: `registration_period_settings_${item === null || item === void 0 ? void 0 : item.registration_period_id}`, htmlType: 'submit', disabled: isLoading, loading: isLoading }, _T('common.save')),
            ] },
            React.createElement(Form, { name: `registration_period_settings_${item === null || item === void 0 ? void 0 : item.registration_period_id}`, form: form, layout: "vertical", disabled: isLoading, onFinish: onFinish, initialValues: getDefaultValue() },
                React.createElement(RegistrationRulesForm, null)))));
};
